import { IconButton, Tooltip } from "@compass/core";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useState } from "react";

export const CopyLinkButton = (props: {
  showCheck: boolean;
  copyLink?: string;
  setShowCheck: (value: boolean) => void;
}) => {
  const handleClick = () => {
    navigator.clipboard.writeText(props.copyLink || window.location.href);
    props.setShowCheck(true);
  };

  return (
    <IconButton onClick={() => handleClick()}>
      {!props.showCheck && <ContentCopyIcon />}
      {props.showCheck && (
        <Tooltip title="Copied URL to clipboard!">
          <CheckCircleOutlineIcon />
        </Tooltip>
      )}
    </IconButton>
  );
};
